import React from "react";
import { useTranslation } from "react-i18next";

const Abouthero = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="hero-sec w-100 bg-[#FFFFFF] rounded-[38px]">
        <div className="max-w-[80%] max-xxxl:max-w-[90%] m-auto pt-[90px] flex items-center max-sm:flex-col max-md:gap-[20px] gap-[152px] justify-center">
          <div className="left-section flex flex-col gap-[22px] w-[50%] max-sm:w-[100%]">
            <h2 className="heading-color tracking-[-3px] leading-[60px] font-sora">
              {t("aboutUs.hero.title")}
            </h2>
            <p className="large max-w-[504px] max-sm:max-w-[100%] leading-[35px] txt-color font-medium">
              {t("aboutUs.hero.desc")}
            </p>
          </div>
          <div className="w-[50%] max-sm:w-[100%]">
            <img src="../../assets/images/about/hero-img.png" alt="" className="w-100 h-100" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Abouthero;
